import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { TopHeaderComponent } from './top-header/top-header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipe } from './Services/filterpipe';
import { ToasterContainerComponent } from '../toaster/toaster-container.component';
import { ToasterComponent } from '../toaster/toaster.component';
import { ToasterService } from '../toaster/toaster.service';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
// import { TranslateModule } from '@ngx-translate/core';  
 


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxPaginationModule ,
    AutocompleteLibModule,
    // TranslateModule
  ],
  exports: [
    MainLayoutComponent,
  ],
  declarations: [
    MainLayoutComponent,
    FooterComponent,
    HeaderComponent,
    TopHeaderComponent,
    SidebarComponent,FilterPipe
  ]
})
export class LayoutModule { }
